import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import DesignationData from '../../../features/designations/DesignationData';
import { useViewDesignationMutation } from '../../../api/designations';

const ViewDesignations = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const [designationDetails, setDesignationDetails] = useState({});

    const { enqueueSnackbar } = useSnackbar();
    const [viewDesignation, { isLoading }] = useViewDesignationMutation();

    useEffect(() => {
        async function fetchData() {
            const bodyFormData = new FormData();
            bodyFormData.append('id', params.id);
            try {
                const response = await viewDesignation(bodyFormData).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setDesignationDetails(response.results);
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
            }
        }
        fetchData();
    }, [params.id, viewDesignation, enqueueSnackbar]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Designations</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/settings/designations')}
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <DesignationData designation={designationDetails} id={params.id} isLoading={isLoading} />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ViewDesignations;
